import React, { useEffect, useMemo, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { hideAllNotification } from 'store/alertes/alertesReducer';

import { useHistory } from 'react-router';
import { deleteAPI, getAPI, reinitialiseAPI } from 'store/apiReducer';
import usagerClientReducer from 'store/usagerReducer';
import * as PropTypes from 'prop-types';
import {
    Button,
    ButtonGroup,
    ButtonLink,
    Col,
    ModalV2,
    ModalV2Content,
    ModalV2Footer,
    ModalV2Title,
    Row,
    SegmentLoader,
} from '@si-armes/dsfr-react';

import SimpleTable from 'components/Commun/Table/SimpleTable';
import {
    API_GET_EMPLOYES_LISTE_METIER_ASSO,
    API_SUPPRIMER_EMPLOYE_METIER_ASSO,
    CONTEXT_GET_EMPLOYES_LISTE,
    CONTEXT_SUPPRIMER_EMPLOYE,
} from 'constants/apiUrls.constants';

import { getPath } from 'utils/router';
import RoutesMonCompte from '../routes';
import RoutesModifierEmploye from '../modifier-employe/routes';
import RoutesEcranGestion from '../gestion/routes';

const ListeEmployesContainer = ({
    isDeleting,
    employes,
    errorSupprimerEmploye,
    isLoading,
    clearAlertes,
}) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [ouvertureModale, setOuvertureModale] = useState(false);
    const [employeASupprimer, setEmployeASupprimer] = useState();

    const suppressionBouton = (item) => {
        setEmployeASupprimer(item);
        setOuvertureModale(true);
    };

    const editionBouton = (data) => {
        history.push(getPath(RoutesModifierEmploye, { id: data?.id }));
    };

    const boutonsActions = (data) => {
        return (
            <ButtonGroup align="right" inline>
                <Button
                    icon="fr-fi-delete-line"
                    variant="secondary"
                    onClick={() => suppressionBouton(data)}
                >
                    Suppression
                </Button>
                <Button
                    icon="fr-fi-edit-line"
                    variant="secondary"
                    onClick={() => editionBouton(data)}
                >
                    Edition
                </Button>
            </ButtonGroup>
        );
    };

    const donnees = useMemo(() => {
        if (Array.isArray(employes) && employes.length > 0 && !isLoading) {
            return employes.map((data) => {
                return [
                    data.identifiant || '',
                    data.nom || '',
                    data.prenomUn || '',
                    data.email || '',
                    data.actif ? 'Actif' : 'Inactif',
                    boutonsActions(data),
                ];
            });
        }

        return [];
    }, [isLoading]);

    const titres = ['Identifiant', 'Nom', 'Prénom', 'Email', 'Compte actif', 'Actions'];

    const handleConfirm = () => {
        dispatch(
            deleteAPI(
                usagerClientReducer,
                `${API_SUPPRIMER_EMPLOYE_METIER_ASSO}/${employeASupprimer?.id}`,
                CONTEXT_SUPPRIMER_EMPLOYE,
            ),
        );
    };

    const fermerModaleMiseAJourCompte = () => {
        setOuvertureModale(false);
    };

    useEffect(() => {
        dispatch(reinitialiseAPI(CONTEXT_SUPPRIMER_EMPLOYE));
        dispatch(
            getAPI(
                usagerClientReducer,
                API_GET_EMPLOYES_LISTE_METIER_ASSO,
                CONTEXT_GET_EMPLOYES_LISTE,
            ),
        );
    }, []);

    useEffect(() => {
        if (!isDeleting && errorSupprimerEmploye === false) {
            fermerModaleMiseAJourCompte();

            dispatch(
                getAPI(
                    usagerClientReducer,
                    API_GET_EMPLOYES_LISTE_METIER_ASSO,
                    CONTEXT_GET_EMPLOYES_LISTE,
                ),
            );

            dispatch(reinitialiseAPI(CONTEXT_SUPPRIMER_EMPLOYE));
        }
    }, [errorSupprimerEmploye]);

    useEffect(() => {
        if (ouvertureModale) {
            clearAlertes();
        }
    }, [ouvertureModale]);

    const renderConfirmSupprimerEmploye = () => {
        return (
            ouvertureModale && (
                <ModalV2
                    id="miseAJour"
                    idModalTitle="miseAJour-titre"
                    size="lg"
                    onClose={fermerModaleMiseAJourCompte}
                >
                    <ModalV2Content>
                        <SegmentLoader isLoading={isDeleting}>
                            <ModalV2Title id="miseAJour-titre">Notification</ModalV2Title>

                            <p>Supprimer l&apos;employé : {employeASupprimer?.email}</p>
                            <p>Etes-vous sûr de supprimer cet employé ?</p>
                        </SegmentLoader>
                    </ModalV2Content>
                    <ModalV2Footer>
                        <ButtonGroup align="right" inline>
                            <Button onClick={fermerModaleMiseAJourCompte}>Annuler</Button>
                            <Button
                                onClick={handleConfirm}
                                disabled={isDeleting}
                                primary
                                content="Confirmer"
                            >
                                Valider
                            </Button>
                        </ButtonGroup>
                    </ModalV2Footer>
                </ModalV2>
            )
        );
    };

    if (!employes && !isLoading) {
        return <div>Aucun employé n&apos;a été trouvé.</div>;
    }

    return (
        <SegmentLoader isLoading={isLoading}>
            <h1>Liste des employés</h1>

            <ButtonLink
                as={Link}
                name="ajouterEmploye"
                to={getPath(RoutesMonCompte.subroutes.ajouterEmploye)}
                variant="secondary"
                icon="fr-icon-add-line"
                iconPosition="left"
            >
                Ajouter un employé
            </ButtonLink>

            <Row gutters>
                <Col>
                    <SimpleTable entete={titres} donnees={donnees} />
                </Col>
            </Row>

            {renderConfirmSupprimerEmploye()}

            <Link to={getPath(RoutesEcranGestion)} style={{ backgroundImage: 'none' }}>
                <Button name="etapePrecedente" variant="secondary" type="button">
                    Retour
                </Button>
            </Link>
        </SegmentLoader>
    );
};

ListeEmployesContainer.propTypes = {
    employes: PropTypes.array,
    isLoading: PropTypes.bool.isRequired,
    isDeleting: PropTypes.bool,
    errorSupprimerEmploye: PropTypes.bool,
    clearAlertes: PropTypes.func.isRequired,
};

export default connect(
    (state) => {
        const { data, isLoading } = state.gestionEmployes.employesManagementStore;

        const {
            data: employeRemoved,
            isLoading: isDeleting,
            erreur: errorSupprimerEmploye,
        } = state.gestionEmployes.supprimerEmployeStore;

        return {
            popInMessageStore: state.popInMessageStore,
            employes: data?.employes,
            isLoading,
            errorSupprimerEmploye,
            employeRemoved,
            isDeleting,
        };
    },
    {
        clearAlertes: hideAllNotification,
    },
)(ListeEmployesContainer);
